import React from 'react'

import {
   FaGitlab,
   FaTelegramPlane,
   FaTwitter,
   FaMediumM,
   FaRedditAlien,
   FaGithubAlt,
   FaChevronLeft,
   FaBars,
   FaExchangeAlt,
   FaEye,
   FaTrashAlt,
   FaCheckDouble,
   FaCheck,
   FaBolt,
   FaShareAlt,
   FaClone,
} from 'react-icons/fa'
import {
   GoSignOut,
} from 'react-icons/go'
import { HiUpload, HiDownload } from 'react-icons/hi'
import { IoBookmarks } from 'react-icons/io5'
import { ImSpinner2 } from 'react-icons/im'
import {
   AiOutlinePlusCircle,
   AiOutlineInfoCircle,
   AiFillWarning,
} from 'react-icons/ai'
import { BiPlus, BiChevronDown } from 'react-icons/bi'
import { VscSettings, VscRefresh, VscClose } from 'react-icons/vsc'

import DesktopNotificationIcon from '../../assets/icons/notification_desktop'
import DesktopHomeIcon from '../../assets/icons/home_desktop'
import DesktopAppsIcon from '../../assets/icons/apps_desktop'
import DesktopWalletIcon from '../../assets/icons/wallet_desktop'
import DesktopDexIcon from '../../assets/icons/dex_desktop'
import DesktopCogIcon from '../../assets/icons/cog_desktop'
import DesktopMoonIcon from '../../assets/icons/moon_desktop'
import DesktopSunIcon from '../../assets/icons/sun_desktop'

const Icon = React.forwardRef(
   ({ className, name, color, size = 20, onClick, ...props }, ref) => {
      const renderIcon = () => {
         switch (name) {
            case 'gitbook':
               return <FaGitlab size={size} />
            case 'telegram':
               return <FaTelegramPlane size={size} />
            case 'twitter':
               return <FaTwitter size={size} />
            case 'medium':
               return <FaMediumM size={size} />
            case 'reddit':
               return <FaRedditAlien size={size} />
            case 'github':
               return <FaGithubAlt size={size} />
            case 'chevron-left':
               return <FaChevronLeft size={size} />
            case 'bell':
               return <DesktopNotificationIcon size={size} color={color} />
            case 'bars':
               return <FaBars size={size} />
            case 'home':
               return <DesktopHomeIcon color={color} size={size} />
            case 'exchange':
               return <DesktopDexIcon color={color} size={size} />
            case 'fa-exchange':
               return <FaExchangeAlt size={size} />
            case 'wallet':
               return <DesktopWalletIcon color={color} size={size} />
            case 'apps':
               return <DesktopAppsIcon color={color} size={size} />
            case 'cog':
               return <DesktopCogIcon color={color} size={size} />
            case 'eye':
               return <FaEye size={size} />
            case 'sign-out':
               return <GoSignOut size={size} />
            case 'trash':
               return <FaTrashAlt size={size} />
            case 'check':
               return <FaCheck size={size} />
            case 'check-double':
               return <FaCheckDouble size={size} />
            case 'upload':
               return <HiUpload size={size} />
            case 'download':
               return <HiDownload size={size} />
            case 'bookmark':
               return <IoBookmarks size={size} />
            case 'bolt':
               return <FaBolt size={size} />
            case 'share':
               return <FaShareAlt size={size} />
            case 'spinner':
               return <ImSpinner2 size={size} />
            case 'clone':
               return <FaClone size={size} />
            case 'plus':
               return <BiPlus size={size} />
            case 'refresh':
               return <VscRefresh size={size} />
            case 'outline-plus':
               return <AiOutlinePlusCircle size={size} />
            case 'settings':
               return <VscSettings size={size} />
            case 'chevron-down':
               return <BiChevronDown size={size} />
            case 'close':
               return <VscClose size={size} />
            case 'info':
               return <AiOutlineInfoCircle size={size} />
            case 'warning':
               return <AiFillWarning size={size} />
            case 'sun':
               return <DesktopSunIcon color={color} size={size} />
            case 'moon':
               return <DesktopMoonIcon color={color} size={size} />
            default:
               return '-'
         }
      }

      return (
         <span className={className} onClick={onClick} ref={ref} {...props}>
            {renderIcon()}
         </span>
      )
   }
)

export default Icon
